module.exports = __webpack_public_path__ + "static/media/translations.1033.06d6ea0e.resx";